module.exports = __webpack_public_path__ + "static/crayola-logo-309198acc89ad1d59b1c51458495f899.png";